import AppHeader from '../AppHeader'

export default {
  name: 'master-tanomail-list',
  async created () {
    await this.getShop()
    await this.getTanomail()
  },
  data () {
    return {
      tanomails: [],
      shopId: '',
      shops: [],
      shopGetCallbackFlag: false,
      searchCallbackFlag: true
    }
  },
  components: {
    AppHeader
  },
  methods: {
    async getShop () {
      this.shopGetCallbackFlag = false
      let data = {}
      let res = await this.$store.dispatch('GET_SHOP_TARGET_STOCK', data)
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })
      this.shops = res.data
      this.shopGetCallbackFlag = true
    },
    async getTanomail () {
      let data = {
        'shop_id': this.shopId
      }
      let res = await this.$store.dispatch('GET_TANOMAIL_LIST', {data: data})
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })

      this.tanomails = res.tanomails
      this.searchCallbackFlag = true
    },
    goTanomailNew () {
      this.$router.push({path: '/master_tanomail/new'})
    },
    goTanomailEdit (tanomailId) {
      this.$router.push({path: `/master_tanomail/${tanomailId}/edit`})
    },
    async tanomailDelete (tanomailId) {
      if (!window.confirm('このたのめーるアカウントを削除しますか？')) {
        return
      }

      await this.$store.dispatch('DELETE_TANOMAIL', {id: tanomailId, data: {}})
      .catch(err => {
        console.log(err)
        return
      })
      this.getTanomail()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/master-tanomail-list.js